import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

const EN_FLAG = () => (
  <svg
    width="22"
    height="16"
    viewBox="0 0 60 40"
    xmlns="http://www.w3.org/2000/svg"
    style={{ borderRadius: 3, flexShrink: 0 }}
  >
    <rect width="60" height="40" fill="#012169" />
    <path d="M0,0 L60,40 M60,0 L0,40" stroke="#fff" strokeWidth="8" />
    <path d="M0,0 L60,40 M60,0 L0,40" stroke="#C8102E" strokeWidth="5" />
    <path d="M30,0 V40 M0,20 H60" stroke="#fff" strokeWidth="12" />
    <path d="M30,0 V40 M0,20 H60" stroke="#C8102E" strokeWidth="8" />
  </svg>
);

const FR_FLAG = () => (
  <svg
    width="22"
    height="16"
    viewBox="0 0 60 40"
    xmlns="http://www.w3.org/2000/svg"
    style={{ borderRadius: 3, flexShrink: 0 }}
  >
    <rect width="60" height="40" fill="#ED2939" />
    <rect width="40" height="40" fill="#fff" />
    <rect width="20" height="40" fill="#002395" />
  </svg>
);

const languages = [
  { code: "en", label: "English", short: "EN", Flag: EN_FLAG },
  { code: "fr", label: "Fran莽ais", short: "FR", Flag: FR_FLAG },
];

export const LanguageSelector = () => {
  const { i18n } = useTranslation();
  const getLanguage = localStorage.getItem("i18nextLng") || "en-US" || "en";
  const [selected, setSelected] = useState(
    getLanguage === "en" || getLanguage === "en-US"
      ? languages[0]
      : languages[1]
  );
  const [open, setOpen] = useState(false);

  const toggle = () => setOpen((o) => !o);
  const select = (lang) => {
    setSelected(lang);
    setOpen(false);
  };

  const handleSelectLanguage = (lang) => {
    if (lang.code === "en") {
      i18n.changeLanguage("en");
    } else if (lang.code === "fr") {
      i18n.changeLanguage("fr");
    }
    select(lang);
    // window.location.reload();
  };

  const handleOutSideClick = (e) => {
    if (!e.target.closest(".language-selector")) {
      setOpen(false);
    }
  };

  useEffect(() => {
    if (!open) return;

    document.addEventListener("click", handleOutSideClick);

    return () => {
      document.removeEventListener("click", handleOutSideClick);
    };
  }, [open]);

  return (
    <div
      style={{ fontFamily: "'Georgia', serif" }}
      className="language-selector"
    >
      <header
        style={{
          height: 64,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          // boxShadow: "0 2px 20px rgba(0,0,0,0.4)"
        }}
      >
        <div style={{ position: "relative" }}>
          <button
            onClick={toggle}
            style={{
              display: "flex",
              alignItems: "center",
              gap: 9,
              background: open
                ? "rgba(232,213,183,0.15)"
                : "rgba(255,255,255,0.06)",
              border: "1px solid #2D53DA !important",
              borderRadius: 8,
              padding: "7px 14px",
              cursor: "pointer",
              color: "#000000",
              fontSize: 13,
              letterSpacing: 1.5,
              fontFamily: "'Georgia', serif",
              transition: "all 0.2s ease",
              minWidth: 110,
              justifyContent: "space-between",
            }}
            onMouseEnter={(e) =>
              (e.currentTarget.style.borderColor = "rgba(232,213,183,0.55)")
            }
            onMouseLeave={(e) =>
              (e.currentTarget.style.borderColor = open
                ? "rgba(232,213,183,0.55)"
                : "rgba(232,213,183,0.25)")
            }
          >
            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
              <selected.Flag />
              <span style={{ fontWeight: 600 }}>{selected.short}</span>
            </div>
            <svg
              width="10"
              height="10"
              viewBox="0 0 10 10"
              style={{
                transform: open ? "rotate(180deg)" : "rotate(0)",
                transition: "transform 0.25s ease",
                opacity: 0.7,
              }}
            >
              <path
                d="M1 3 L5 7 L9 3"
                stroke="#e8d5b7"
                strokeWidth="1.5"
                fill="none"
                strokeLinecap="round"
              />
            </svg>
          </button>

          {open && (
            <div
              style={{
                position: "absolute",
                top: "calc(100% + 8px)",
                right: 0,
                background: "#16213e",
                border: "1px solid #2D53DA !important",
                borderRadius: 10,
                overflow: "hidden",
                boxShadow: "0 12px 40px rgba(0,0,0,0.5)",
                minWidth: 160,
                animation: "fadeSlide 0.18s ease",
              }}
            >
              <style>{`
                @keyframes fadeSlide {
                  from { opacity: 0; transform: translateY(-6px); }
                  to   { opacity: 1; transform: translateY(0); }
                }
              `}</style>
              {languages.map((lang, i) => (
                <button
                  key={lang.code}
                  onClick={() => handleSelectLanguage(lang)}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 12,
                    width: "100%",
                    background:
                      selected.code === lang.code
                        ? "rgba(232,213,183,0.12)"
                        : "transparent",
                    border: "none",
                    borderTop:
                      i !== 0 ? "1px solid rgba(232,213,183,0.08)" : "none",
                    padding: "12px 16px",
                    cursor: "pointer",
                    color: "#e8d5b7",
                    fontSize: 14,
                    letterSpacing: 0.5,
                    fontFamily: "'Georgia', serif",
                    textAlign: "left",
                    transition: "background 0.15s ease",
                  }}
                  onMouseEnter={(e) => {
                    if (selected.code !== lang.code)
                      e.currentTarget.style.background =
                        "rgba(232,213,183,0.07)";
                  }}
                  onMouseLeave={(e) => {
                    if (selected.code !== lang.code)
                      e.currentTarget.style.background = "transparent";
                  }}
                >
                  <lang.Flag />
                  <div>
                    <div style={{ fontWeight: 600, fontSize: 13 }}>
                      {lang.short}
                    </div>
                    <div style={{ fontSize: 11, opacity: 0.55, marginTop: 1 }}>
                      {lang.label}
                    </div>
                  </div>
                  {selected.code === lang.code && (
                    <svg
                      width="12"
                      height="12"
                      viewBox="0 0 12 12"
                      style={{ marginLeft: "auto" }}
                    >
                      <path
                        d="M2 6 L5 9 L10 3"
                        stroke="#e8d5b7"
                        strokeWidth="1.8"
                        fill="none"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  )}
                </button>
              ))}
            </div>
          )}
        </div>
      </header>
    </div>
  );
};
